import { FC, useContext } from 'react'
import { useChatBoxFile } from '../../hooks/useChatBoxFile'
import { ChatBoxFileConfirmationHeader } from './ChatBoxFileConfirmationHeader'
import { ChatBoxFileConfirmationBody } from './ChatBoxFileConfirmationBody'
import { ChatContext } from '../../context/ChatContext'
import { ModalDialog } from '../../../common/components/ModalDialog'

export const ChatBoxFileConfirmation: FC = () => {
  const { form } = useContext(ChatContext)
  const file = useChatBoxFile()

  return (
    <ModalDialog
      opened={!!file}
      onClose={() => {
        form.resetField('files')
      }}
    >
      {file && (
        <>
          <ChatBoxFileConfirmationHeader file={file} />
          <ChatBoxFileConfirmationBody file={file} />
        </>
      )}
    </ModalDialog>
  )
}
